import _isString from 'lodash/isString';

export default class Storage {
    get (key) {
        return new Promise(resolve => {
            const isArray = Array.isArray(key);
            const keys = isArray ? key : [key];

            const values = {};

            keys.forEach(key => (values[key] = global.localStorage.getItem(key)));

            resolve(isArray ? values : values[key]);
        });
    }

    set (keyOrData, value) {
        return new Promise(resolve => {
            const dataset = _isString(keyOrData)
                ? {
                    [keyOrData]: value,
                }
                : keyOrData;

            Object.entries(dataset).forEach(([key, value]) =>
                global.localStorage.setItem(key, value)
            );

            resolve();
        });
    }

    remove (key) {
        return new Promise(resolve => {
            const keys = Array.isArray(key) ? key : [key];

            keys.forEach(key => global.localStorage.removeItem(key));

            resolve();
        });
    }
}
